// extracted by mini-css-extract-plugin
module.exports = {"input":"Option_input__3-_i1"};